import React, { useEffect, useState } from "react";
import SignUp from "./SignUp";

const singleChoice =[
  {"value": "Student", "description": "You are a student enrolled in the institution."},
  {"value": "Faculty", "description": "You are a faculty member teaching or working in the institution."},
  {"value": "Administrative Staff", "description": "You are a staff member responsible for administrative tasks in the institution."},
  {"value": "Other", "description": "Please specify your role if it is not listed above."}
]
const whereSell = [
  {"value": "Computer Science", "description": "Department of Computer Science and Engineering."},
  // {"value": "Electrical Engineering", "description": "Department of Electrical Engineering."},
  {"value": "Mechanical Engineering", "description": "Department of Mechanical Engineering."},
  {"value": "Civil Engineering", "description": "Department of Civil Engineering."},
  {"value": "Business Administration", "description": "Department of Business Administration."},
  // {"value": "Arts and Humanities", "description": "Department of Arts and Humanities."},
  // {"value": "Science", "description": "Department of Science."},
  {"value": "Other", "description": "Please specify any other department you are associated with."}
]

const whatSell = [
  {"value": "Student Management", "description": "Manage student records, including enrollment, attendance, and academic performance."},
  {"value": "Faculty Management", "description": "Manage faculty records, including teaching assignments, attendance, and performance evaluations."},
  {"value": "Course Management", "description": "Manage course information, including scheduling, curriculum, and assignments."},
  // {"value": "Attendance Tracking", "description": "Track attendance for both students and faculty."},
  {"value": "Gradebook", "description": "Manage and track grades for courses."},
  // {"value": "Scheduling", "description": "Manage class schedules and timetables."},
  {"value": "Reporting and Analytics", "description": "Generate reports and analyze data related to student and faculty performance."},
  // {"value": "Integration with other systems", "description": "Integrate the student and faculty management system with other existing systems."},
  {"value": "Other", "description": "Please specify any other functionalities you are interested in."}
]
const Onboarding = () => {
  const [index, setIndex] = useState(1);
  return (
   <>
    {index <=3 && <div className="onboarding_form">
      <div className="container">
        <div className="onboarding_wrapper">
          <div className="logo">
            <h2>#. Getting started</h2>
          </div>

          {index == 1 && (
            <>
              <progress id="file" value="1" max="100"></progress>
              <h3>How would you describe your role?</h3>
              <p>Please select the option that best describes your role.</p>
              <div className="from">
                {singleChoice?.map((option,idx)=>(
                  <div className="input_field">
                    <i class="fa-solid fa-circle-dot"></i>
                    <label htmlFor="">{option?.value}</label>
                  </div>
                ))}
              </div>
            </>
          )}

          {index == 2 && (
            <>
              <progress id="file" value="25" max="100"></progress>
              <h3>Which department are you associated with?</h3>
              <p>Please select the department(s) you are associated with.</p>
              <div className="from">
                {whereSell?.map((option, idx) => (
                  <div className="input_field_multiselect">
                    <input type="checkbox" name="" id={option?.value} />
                    <label htmlFor={option?.value}>
                      <p>{option?.value}</p>
                      <small>{option?.description}</small>
                    </label>
                    {/* <i class="fa-solid fa-store"></i> */}
                  </div>
                ))}
              </div>
            </>
          )}

          {index == 3 && (
            <>
              <progress id="file" value="70" max="100"></progress>
              <h3>What functionalities are you primarily interested in?</h3>
              <p>Please select the functionalities you are primarily interested in.</p>
              <div className="from">
                {whatSell?.map((option, idx) => (
                  <div className="input_field_multiselect">
                    <input type="checkbox" name="" id={option?.value} />
                    <label htmlFor={option?.value}>
                      <p>{option?.value}</p>
                      <small>{option?.description}</small>
                    </label>
                    {/* <i class="fa-solid fa-store"></i> */}
                  </div>
                ))}
              </div>
            </>
          )}

          <div className="nav_controls">
            <div className="first">
              {index > 1 && (
                <button
                  className="btn_normal"
                  onClick={() => setIndex(index==1?1:index - 1)}
                >
                  <i class="fa-solid fa-angle-left"></i> Back
                </button>
              )}
            </div>
            <div className="second">
              <button className="btn_normal">Skip All</button>
              <button className="btn_normal">Skip</button>
              <button
                className="btn_colored"
                onClick={() => setIndex(index + 1)}
              >
                Next <i class="fa-solid fa-angle-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>}
    {index >3 &&<SignUp/>}
   </>
  );
};

export default Onboarding;
